export default __webpack_public_path__ + "static/media/property_208.22dacc9d.png";